export const USERS_ACTION_TYPES = {
  LOAD_USERS: 'users/LOAD_USERS',
  LOAD_USER: 'users/LOAD_USER',
  CREATE_USER: 'users/CREATE_USER',
  EDIT_USER: 'users/EDIT_USER',
  DELETE_USER: 'users/DELETE_USER',
  BLOCK_USER: 'users/BLOCK_USER',
  UNBLOCK_USER: 'users/UNBLOCK_USER',
  CONVERT_FAKE: 'users/CONVERT_FAKE',
};

export function loadUsers(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.LOAD_USERS,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function loadUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.LOAD_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function createUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.CREATE_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function editUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.EDIT_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function deleteUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.DELETE_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function blockUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.BLOCK_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function unblockUser(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.UNBLOCK_USER,
        payload,
        resolve,
        reject,
      })
    })
  }
}

export function convertFake(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USERS_ACTION_TYPES.CONVERT_FAKE,
        payload,
        resolve,
        reject,
      })
    })
  }
}